import { reverseOffset } from './functions';

type FirestoreDateLike =
  | Date
  | null
  | undefined
  | {
      toDate: () => Date;
    };

const toJsDate = (value: FirestoreDateLike) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  return null;
};

export const normalizeGigEventDate = (eventDate: FirestoreDateLike) => {
  const jsDate = toJsDate(eventDate);
  const normalizedDate = reverseOffset(jsDate);

  if (!normalizedDate) {
    throw new Error('Gigs require an event date before they can be saved.');
  }

  return normalizedDate;
};

export const getGigEventLink = (relEventId: string | null | undefined, eventDate: FirestoreDateLike) => {
  if (!relEventId) {
    throw new Error('Gigs require an event before they can be saved.');
  }

  return {
    relEventId,
    relEventDate: normalizeGigEventDate(eventDate)
  };
};